if (!customElements.get('localization-form')) {
  // Choosing one of these languages also switches the visitor to that country's market
  const LANGUAGE_COUNTRY_MAP = {
    sk: 'SK',
    cs: 'CZ',
    pl: 'PL',
    hu: 'HU',
    ro: 'RO',
    bg: 'BG',
    hr: 'HR',
    sl: 'SI',
    lt: 'LT'
  };

  customElements.define('localization-form', class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]')
      };

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form && this.elements.input.name === 'locale_code') setCountryForLanguage(form, this.elements.input.value);
      if (form) form.submit();
    }
  });

  function getCountryForLanguage(languageCode) {
    const countryCode = LANGUAGE_COUNTRY_MAP[(languageCode || '').split('-')[0].toLowerCase()];
    return countryCode && (window.availableCountries || []).includes(countryCode) ? countryCode : null;
  }

  function setCountryForLanguage(form, languageCode) {
    const countryCode = getCountryForLanguage(languageCode);
    if (!countryCode) return;

    let countryInput = form.querySelector('input[name="country_code"]');
    if (!countryInput) {
      countryInput = document.createElement('input');
      countryInput.type = 'hidden';
      countryInput.name = 'country_code';
      form.appendChild(countryInput);
    }
    countryInput.value = countryCode;
  }

  // Visitors landing directly on a language URL (e.g. /sk) keep their previous market,
  // so switch them once per session; a country picked manually afterwards is kept
  (function syncCountryWithLanguage() {
    const shopify = window.Shopify || {};
    const countryCode = getCountryForLanguage(shopify.locale);
    if (shopify.designMode || !countryCode || countryCode === shopify.country) return;

    const storageKey = 'localization-synced-locale';
    try {
      if (sessionStorage.getItem(storageKey) === shopify.locale) return;
      sessionStorage.setItem(storageKey, shopify.locale);
    } catch (e) {
      return;
    }

    const form = document.querySelector('localization-form input[name="locale_code"]')?.form;
    if (!form) return;
    setCountryForLanguage(form, shopify.locale);
    form.submit();
  })();
}
